import { render } from "./PER_EmployeesDetails.vue?vue&type=template&id=6d3ab869&ts=true"
import script from "./PER_EmployeesDetails.vue?vue&type=script&lang=ts"
export * from "./PER_EmployeesDetails.vue?vue&type=script&lang=ts"

import "./PER_EmployeesDetails.vue?vue&type=style&index=0&id=6d3ab869&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__